import React from "react";
import StyledSection from "components/global/Section";
import SuccessIcon from "components/Icons/SuccessIcon";
import { useTranslation } from "react-i18next";
import {
  InfoBox,
  InfoBoxHeader,
  InfoBoxContent,
  InfoBoxParagraph,
} from "./styles";

function SharepointPermissionsGranted() {
  const { t } = useTranslation();

  return (
    <StyledSection type="login" spaceTop>
      <InfoBox>
        <InfoBoxHeader>
          <SuccessIcon
            sx={{ width: "2rem", height: "2rem", marginRight: "0.8rem" }}
          />
          {t("info.sharepointPermissionsGranted.header")}
        </InfoBoxHeader>
        <InfoBoxContent>
          <InfoBoxParagraph>
            {t("info.sharepointPermissionsGranted.infoHeader")}
          </InfoBoxParagraph>
          <InfoBoxParagraph>
            {t("info.sharepointPermissionsGranted.info")}
          </InfoBoxParagraph>
        </InfoBoxContent>
      </InfoBox>
    </StyledSection>
  );
}

export default SharepointPermissionsGranted;
